import React from 'react';

interface WizardCardProps {
  children: React.ReactNode;
  header?: React.ReactNode;
  footer?: React.ReactNode;
}

const WizardCard: React.FC<WizardCardProps> = ({
  children,
  header,
  footer,
}) => {
  return (
    <div className="w-6xl mx-auto px-8">
      <div className="bg-white rounded-lg shadow-sm">
        {header && (
          <div className="border-b border-gray-200 px-8 py-6">{header}</div>
        )}

        <div className="px-8 py-8">{children}</div>

        {footer && (
          <div className="border-t border-gray-200 px-8 py-6">{footer}</div>
        )}
      </div>
    </div>
  );
};

export default WizardCard;
